export const environment = {
  production: true,
  serviceBasePublicUrl: "https://elevadores.procempa.com.br/etpelevadores/rest/public"
};
